import { createUseStyles } from 'react-jss'
import { DARK_GRAY_11, DARK_GRAY_05 } from '@omnilert/components'

export default createUseStyles({
  container: {
    borderRadius: '5px',
    boxShadow: `0px 0px 3px ${DARK_GRAY_05}, 0px 4px 15px ${DARK_GRAY_11}`,
    display: 'flex',
    flexDirection: 'column',
    margin: '20px',
    overflowY: 'auto',
    textAlign: 'center'
  },
  logoContainer: {
    textAlign: 'center',
    marginTop: '25px'
  },
  messageBody: {
    backgroundColor: 'var(--secondary__page__background__color)',
    padding: '40px',
    textAlign: 'center'
  },
  messageDescription: {
    color: 'var(--registration__message__text__color)',
    display: 'flex',
    fontSize: '15px',
    justifyContent: 'center',
    lineHeight: '20px',
    textAlign: 'left',
    whiteSpace: 'pre-line',
    width: '100%',
    wordBreak: 'break-word'
  },
  text: {
    '& a': {
      color: 'var(--registration__link__text__color)',
      textDecoration: 'underline'
    }
  },
  wrapper: {
    backgroundColor: 'var(--section__background__color)',
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  }
})
